import React, { useEffect, useState, useRef } from "react";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import { Toast } from "primereact/toast";
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css";

Modal.setAppElement("#root"); // replace '#root' with the id of your app's root element

export const PassModal = ({ empSelected, currentEmp, onPassChange }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isMatchError, setIsMatchError] = useState(false);

  const openModal = (e) => {
    e.preventDefault();

    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setPassword("");
    setConfirmPassword("");
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    // Check for match only if the password has started being typed
    if (event.target.value.length > 0) {
      setIsMatchError(event.target.value !== confirmPassword);
    } else {
      setIsMatchError(false); // Reset error if password is cleared
    }
  };

  const handleConfirmChange = (event) => {
    setConfirmPassword(event.target.value);
    setIsMatchError(event.target.value !== password); // Check for match on confirm change
  };

  useEffect(() => {
    if (password === confirmPassword && confirmPassword.length > 0) {
      document.getElementById("password-change-confirm-btn").disabled = false;
      document.getElementById("password-change-confirm-btn").className =
        "bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline";
    } else {
      if (document.getElementById("password-change-confirm-btn") !== null) {
        document.getElementById("password-change-confirm-btn").disabled = true;
        document.getElementById("password-change-confirm-btn").className =
          "bg-green-500 opacity-50 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline cursor-not-allowed pointer-events-none";
      }
    }
  }, [password, confirmPassword]);

  useEffect(() => {
    if (empSelected === true) {
      document.getElementById("modal-open-btn").disabled = false;
      document.getElementById("modal-open-btn").className =
        "bg-red-200 hover:bg-red-700 px-3 py-2 rounded focus:outline-none focus:shadow-outline text-gray-500 hover:text-white hover:border-black border-2 border-red-700";
    } else {
      document.getElementById("modal-open-btn").disabled = true;
    }
  }, [empSelected]);

  const handlePasswordSubmit = async () => {
    const url = `/api/changePassword/${currentEmp}`;
    const passUpdate = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: localStorage.token,
      },
      body: JSON.stringify({
        newPass: password,
      }),
    });

    if (passUpdate.ok) {
      onPassChange(true);
      console.log("password updated");
      closeModal();
    }
  };

  const toast = useRef(null);

  const accept2 = () => {
    toast.current.show({
      severity: "success",
      summary: "Mot de passe modifié",
      detail: "Mot de passe modifié avec succès",
      life: 3000,
    });
  };

  return (
    <div>
      <button
        className="bg-gray-200 px-3 py-2 rounded focus:outline-none focus:shadow-outline text-gray-500 border-red-700"
        onClick={openModal}
        id="modal-open-btn"
      >
        Changement de mot de passe
      </button>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Add Comment"
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
          },
        }}
      >
        <h5>Changement de mot de passe</h5>
        <div className="">
          <div class="mb-4">
            <label for="password" class="block text-gray-700 text-sm  mb-2">
              Nouveau Mot de passe
            </label>
            <input
              onChange={handlePasswordChange}
              type="password"
              id="password"
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>
          <div class="mb-4">
            <label for="password" class="block text-gray-700 text-sm mb-2">
              Confirmer le mot de passe
            </label>
            <input
              onChange={handleConfirmChange}
              type="password"
              id="passwordConfirm"
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>
        </div>
        <div className="container mx-auto h-10  mb-2">
          {isMatchError && password.length > 0 && (
            <p className="error-message text-red-500">
              Les deux champs ne correspondent pas!
            </p>
          )}

          {password === confirmPassword && confirmPassword.length > 0 && (
            <p className="error-message text-green-500">Mot de passe valide!</p>
          )}
        </div>

        <div className=" flex content-center justify-center space-x-2">
          <button
            className="bg-green-500 opacity-50 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline cursor-not-allowed pointer-events-none"
            onClick={handlePasswordSubmit}
            id="password-change-confirm-btn"
          >
            Confirmer
          </button>
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            onClick={closeModal}
          >
            Annuler
          </button>
        </div>
        <Toast ref={toast} />
      </Modal>
      <ToastContainer />
    </div>
  );
};
